import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { disablePageScroll, enablePageScroll } from "scroll-lock";
import { useState } from "react";

import Logo from "./assets/logo.png";
import { Menus } from "./Utils";
import DesktopMenu from "./components/DesktopMenu";
import MobMenu from "./components/MobMenu";
import HomePage from "./components/HomePage";
import Project from "./components/ThanlyinIndustrial&CommercialPark";
import ContactPage from "./components/Contact";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { LanguageProvider, useLanguage } from "./LanguageContext";
import { ChevronDown } from "lucide-react";
import AboutUs from "./components/AboutUs";

const firebaseConfig = {
  apiKey: "AIzaSyBQEsdQfKT2Apzl1i19Z7X0iOg98TQdUI8",
  authDomain: "mcbwi-web.firebaseapp.com",
  projectId: "mcbwi-web",
  storageBucket: "mcbwi-web.firebasestorage.app",
  messagingSenderId: "4748749336",
  appId: "1:4748749336:web:6ac77e99448f58f001716d",
  measurementId: "G-18ESZ57W9G",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default function App() {
  return (
    <LanguageProvider>
      <Router>
        <MainLayout />
      </Router>
    </LanguageProvider>
  );
}

const MainLayout = () => {
  const { language, setLanguage } = useLanguage();
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const location = useLocation();
  const [openNavigation, setOpenNavigation] = useState(false);

  const languageLabels = {
    English: {
      English: "English",
      Burmese: "Burmese",
      Chinese: "Chinese",
    },
    Burmese: {
      English: "အင်္ဂလိပ်",
      Burmese: "ဗမာ",
      Chinese: "တရုတ်",
    },
    Chinese: {
      English: "英语",
      Burmese: "缅甸语",
      Chinese: "中文",
    },
  };

  const toggleNavigation = () => {
    if (openNavigation) {
      setOpenNavigation(false);
      enablePageScroll();
    } else {
      setOpenNavigation(true);
      disablePageScroll();
    }
  };

  const languages = ["English", "Burmese", "Chinese"];

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    setShowLanguageDropdown(false);
  };

  return (
    <div className="pt-0 lg:pt-0 overflow-hidden">
      {/* Header */}
      <header
        className={`fixed top-0 left-0 right-0 flex items-center bg-black shadow-md z-50 transition-all`}
      >
        <nav className="px-4 flex items-center justify-between w-full max-w-7xl mx-auto">
          {/* Logo Section */}
          <div
            className="flex items-center gap-x-3 relative z-10 cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <img src={Logo} alt="Logo" className="w-8 h-12" />
            <div className="leading-4 p-2 text-white">
              <h3 className="text-[16px] font-semibold">Myanmar City</h3>
              <h3 className="text-[12px] font-semibold">Bonded Warehouse &</h3>
              <h3 className="text-[12px] font-semibold">Industrial Co.,Ltd.</h3>
            </div>
          </div>

          {/* Desktop Navigation */}
          <ul className="gap-x-4 hidden lg:flex">
            {Menus().map((menu) => (
              <DesktopMenu
                key={menu.id}
                menu={menu}
                activePath={location.pathname}
              />
            ))}
          </ul>

          {/* Right Section: Language Switch & Mobile Menu */}
          <div className="flex items-center gap-x-5">
            {/* Language dropdown - hidden on mobile, shown on desktop */}
            <div className="hidden lg:block relative">
              <button
                aria-label="Language"
                className="bg-white/5 px-3 py-1.5 shadow rounded-xl text-white text-sm flex items-center gap-1"
                onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}
              >
                {languageLabels[language][language]}{" "}
                {/* Changed from {language} */}{" "}
                <ChevronDown
                  size={16}
                  className={`transition-transform ${
                    showLanguageDropdown ? "rotate-180" : ""
                  }`}
                />
              </button>

              {showLanguageDropdown && (
                <div className="absolute right-0 mt-2 w-32 bg-black/90 backdrop-blur rounded-md shadow-lg z-50">
                  {languages.map((lang) => (
                    <button
                      key={lang}
                      className={`w-full text-left px-4 py-2 text-sm text-white hover:bg-white/10 ${
                        language === lang ? "bg-white/20" : ""
                      }`}
                      onClick={() => handleLanguageChange(lang)}
                    >
                      {languageLabels[language][lang]}
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Mobile menu button - shown only on mobile */}
            <div className="lg:hidden">
              <MobMenu
                Menus={Menus()}
                toggleNavigation={toggleNavigation}
                openNavigation={openNavigation}
              />
            </div>
          </div>
        </nav>
      </header>

      {/* Main Content */}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/project" element={<Project />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </main>
    </div>
  );
};
